export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 35 35" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-400.000000, -6200.000000)" fill="#000000" fillRule="nonzero">
                    <g id="编组-29" transform="translate(400.000000, 6200.000000)">
                        <path
                            d="M28.775773,0 C32.1369291,0 34.8758261,2.66420465 34.995895,5.99604495 L35,6.224227 L35,28.775773 C35,32.1369291 32.3357954,34.8758261 29.0039551,34.995895 L28.775773,35 L6.224227,35 C2.86307091,35 0.124173904,32.3357954 0.00410497799,29.0039551 L0,28.775773 L0,6.224227 C0,2.86307091 2.66420465,0.124173904 5.99604495,0.00410497799 L6.224227,0 L28.775773,0 Z M19.223791,21.2198068 L16.2974261,21.2198068 L16.2974261,29.673913 L19.223791,29.673913 L19.223791,21.2198068 Z M23.4043838,6.84782609 L20.8959995,8.37179141 L25.2022548,15.6183749 L27.7106391,14.0944095 L23.4043838,6.84782609 Z M11.8245867,6.84782609 L7.51833138,14.0944095 L10.0267157,15.6183749 L14.332971,8.37179141 L11.8245867,6.84782609 Z"
                            id="5-3-Shore-Power--input"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
